import { render } from "./Menu.vue?vue&type=template&id=8c819e66&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=8c819e66&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c819e66"]])

export default __exports__